import React, { useState } from "react";
import LocationsTable from "../../../Components/BoltTable/BoltTable";
import {
  deleteStorageLocations,
  getStorageLocations,
} from "../../../services/WarehouseServices/storageMap.services";
import Tooltip from "../../../Components/Tooltip/Tooltip";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import { FcPlus } from "react-icons/fc";
import LocationModal from "./Components/LocationModal";
import { AiOutlineBarcode } from "react-icons/ai";
import LabelModal from "../../Products/Components/LabelModal/LabelModal";
import AddImage from "../../../assets/images/add-image.png";
import {
  TotalSpaceColumn,
  Dimensions,
  Weight,
} from "../../Products/Product/ProductService";
import Confirm from "../../../Components/Popups/Confirm";
import Image from "../../../assets/images/photo.png";
import ImagesModal from "../../../Components/Modals/ImagesModal";
import { updatePalletsLocation } from "../../../services/product.service";
import { showSnackBar } from "../../../store/common/snackBarSlice";
import { useDispatch } from "react-redux";
import { convertTime } from "../../../helpers/helpers";
import BoltButton from "../../../Components/UI/Buttons/BoltButton";
import { useTranslation } from "react-i18next";

const Locations = ({ setSnack }) => {
  const { t } = useTranslation(["warehouse", "common"]);
  // new states
  const [locations, setLocations] = useState([]);
  const [editLocationModal, setEditLocationModal] = useState();
  const [addLocationModal, setAddLocationModal] = useState();
  const [labelModal, setLabelModal] = useState(false);
  const [confirmBox, setConfirmBox] = useState();
  const [deleting, setDeleting] = useState(false);
  const [imagesModal, setImagesModal] = useState();
  const dispatch = useDispatch();
  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("locations.name"),
      field_name: "name",
      render: (row) => <>{row?.name ?? "-"}</>,
      fixed: "left",
      width: "200px",
    },
    {
      id: 2,
      label: t("locations.code"),
      render: (row) => <>{row?.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("locations.dimensionsLWH"),
      render: (row) => (
        <>
          <Dimensions
            length={row?.length ?? 0}
            width={row?.width ?? 0}
            height={row?.height ?? 0}
            unit={row?.unit === "imperial" ? "inch" : "cm"}
            space={true}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("locations.weightCapacity"),
      field_name: "weight_capacity",
      render: (row) => (
        <>
          <Weight
            weight={row?.weight_capacity ?? 0}
            unit={row?.unit === "imperial" ? "lb" : "kg"}
            space={true}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("locations.volumeCapacity"),
      field_name: "total-volume",
      render: (row) => (
        <>
          <TotalSpaceColumn
            length={row?.length ?? 0}
            width={row?.width ?? 0}
            height={row?.height ?? 0}
            unit={row?.unit === "imperial" ? "inch" : "cm"}
            quantity={1}
            space={true}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("locations.cost"),
      field_name: "cost",
      render: (row) => <>{row?.cost ? `${row?.cost}$` : "0$"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("locations.color"),
      field_name: "color",
      render: (row) => (
        <div className="flex items-center">
          {row?.color ? (
            <div
              style={{ backgroundColor: row?.color }}
              className={`mr-1 w-[16px] h-[16px] border border-solid border-grey-500`}
            ></div>
          ) : null}
        </div>
      ),
      width: "200px",
    },
    {
      id: 8,
      label: t("locations.media"),
      field_name: "media",
      render: (row) => (
        <div className="shipper__attachments_thumbnail_wrap">
          {row?.media?.length === 0 ? (
            <img
              src={AddImage}
              loading="lazy"
              onClick={() => setImagesModal(row)}
            />
          ) : (
            <img
              src={Image}
              loading="lazy"
              onClick={() => setImagesModal(row)}
            />
          )}
        </div>
      ),
      width: "200px",
    },
    {
      id: 9,
      label: t("locations.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 10,
      label: t("locations.actions"),
      render: (row, rowIndex) => (
        <div className="table_action__wrap">
          <Tooltip title={t("locations.updateLocation")}>
            <div
              className="table_action__btn"
              onClick={() => setEditLocationModal(row)}
            >
              <FaRegEdit size={10} />
              {t("common:actions.edit")}
            </div>
          </Tooltip>

          <Tooltip title={t("locations.deleteLocation")}>
            <div
              className="table_action__btn"
              onClick={() => setConfirmBox(row?.id)}
            >
              <MdOutlineCancel size={10} />
              {t("common:actions.delete")}
            </div>
          </Tooltip>
          {row?.code ? (
            <Tooltip title={t("locations.printBarcode")}>
              <div
                className="table_action__btn"
                onClick={() => setLabelModal({ row, rowIndex })}
              >
                <AiOutlineBarcode size={10} />
                {t("locations.barcode")}
              </div>
            </Tooltip>
          ) : null}
        </div>
      ),
      width: "200px",
      fixed: "right",
    },
  ];

  const getAllLocations = async (page, perPage, filter, nestedSearch) => {
    let response;
    response = await getStorageLocations(page, perPage, filter, nestedSearch);
    if (!response.error) {
      setLocations(response?.data?.result);
    }
  };

  const handleAddImages = async (images) => {
    const data = new FormData();
    for (let i = 0; i < images.length; i++) {
      data.append("media[]", images[i]);
    }
    const response = await updatePalletsLocation(imagesModal?.id, data);
    if (!response.error) {
      const updatedLocations = locations?.data?.map((location) =>
        location.id === imagesModal?.id ? response?.data?.result : location
      );
      setLocations({ ...locations, data: updatedLocations });
      setImagesModal(response?.data?.result);
      dispatch(
        showSnackBar({
          text: response.message ?? t("locations.imagesUpdatedSuccessfully"),
          severity: "success",
        })
      );
    } else {
      dispatch(
        showSnackBar({
          text: response.message ?? t("common:messages.somethingWentWrong"),
          severity: "error",
        })
      );
    }
    return response;
  };

  const handleDeleteLocation = async (id) => {
    setDeleting(true);
    let response;
    response = await deleteStorageLocations(id);
    setDeleting(false);
    if (!response.error) {
      setLocations((prevLocations) => {
        return {
          ...prevLocations,
          data: prevLocations.data?.filter((loc) => loc.id !== id),
        };
      });
      setConfirmBox(false);
    }
  };

  return (
    <>
      <Confirm
        open={confirmBox}
        setOpen={setConfirmBox}
        handleConfirm={() => {
          handleDeleteLocation(confirmBox);
        }}
        loader={deleting}
      />
      <ImagesModal
        heading={t("locations.locationsMedia")}
        open={imagesModal}
        setOpen={setImagesModal}
        images={imagesModal?.media}
        addImages={handleAddImages}
        setSnack={setSnack}
      />
      <LocationModal
        setSnack={setSnack}
        open={editLocationModal}
        setOpen={setEditLocationModal}
        type="edit"
        previousData={{
          name: editLocationModal?.name,
          unit: editLocationModal?.unit ?? "imperial",
          length: editLocationModal?.length,
          width: editLocationModal?.width,
          height: editLocationModal?.height,
          weight_capacity: editLocationModal?.weight_capacity,
          cost: editLocationModal?.cost,
          color: editLocationModal?.color ?? "white",
          is_use_able: ["true", true, "1"].includes(
            editLocationModal?.is_use_able
          ),
          media: editLocationModal?.media,
        }}
        locations={locations}
        setLocations={setLocations}
      />
      <LocationModal
        setSnack={setSnack}
        open={addLocationModal}
        setOpen={setAddLocationModal}
        type="add"
        locations={locations}
        setLocations={setLocations}
      />
      <LabelModal
        open={labelModal}
        setOpen={setLabelModal}
        setSnack={setSnack}
        labelData={{
          code: labelModal?.row?.code,
          name: labelModal?.row?.name,
          image: labelModal?.row?.media?.find((image) => image?.is_primary)
            ?.file,
        }}
        title={t("locations.palletsBarcode")}
        subtitle={`${labelModal?.row?.name ?? ""}`}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <LocationsTable
          tableTitle={t("locations.locations")}
          tableId="locationsTableforWarehouse"
          message={t("locations.noLocationsAvailableToDisplay")}
          searchPlaceHolder={t("locations.searchLocations")}
          columns={columns}
          data={locations}
          getAllData={getAllLocations}
          headerButtons={
            <div className="flex gap-1 flex-wrap">
              <BoltButton
                icon={FcPlus}
                label={t("locations.addLocation")}
                onClick={() => setAddLocationModal(true)}
                variant="success"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </>
  );
};

export default Locations;
